/***
 *
 *   KANBAN COLUMN
 *   Ported from ui-reference/src/components/tickets/kanban-column.tsx.
 *
 *   Status colour comes from status_template[].key → --status-*, with a
 *   neutral fallback for unknown keys (trap 5). Cards are not draggable:
 *   ticket status is driven by the integration (ClickUp → webhook), so there
 *   is no client-side move to perform.
 *
 **********/

import Style, { STATUS_BAR } from './status.tailwind';
import { TicketItem } from './ticket';
import { useTranslate } from 'app/translations';
import { cn } from 'components/lib';

export const TicketStatus = (props) => {
    const { item } = props;
    const { _t } = useTranslate();

    const filteredTickets = (props.tickets || []).filter((ticket) => {
        return !ticket.is_archived;
    });

    const isEmpty = filteredTickets.length === 0;
    const barClass = STATUS_BAR[item.key] || STATUS_BAR.closed;

    return (
        <div className={Style.container}>
            <div className={Style.header}>
                <div className={Style.headerRow}>
                    <h3 className={Style.title}>
                        {_t(`ticket.category.status.${item.key}`) || item.label}
                    </h3>
                    <span className={Style.count}>{filteredTickets.length}</span>
                </div>
                <div className={cn('mt-2.5 h-[3px] w-full rounded-full', barClass)} aria-hidden />
            </div>

            <div className={Style.body}>
                <div className={Style.droppable}>
                    {isEmpty && (
                        <div className={Style.empty}>
                            <p className={Style.emptyTitle}>
                                {_t('ticket.kanban.emptyColumnTitle')}
                            </p>
                            <p className={Style.emptyHint}>
                                {_t('ticket.kanban.emptyColumnHint')}
                            </p>
                        </div>
                    )}
                    {filteredTickets.map((ticket) => (
                        <TicketItem
                            key={ticket.id || ticket.number}
                            data={ticket}
                            status={item.label}
                        />
                    ))}
                </div>
            </div>
        </div>
    );
};
